/// <reference types="@emotion/react/types/css-prop" />
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import tz from 'moment-timezone'
import React from 'react'
import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import 'url-search-params-polyfill'

import Root from 'Root'

tz()

export interface ProcessEnv {
  env: {
    [key: string]: string | undefined
  }
}

declare let process: ProcessEnv

const {
  NODE_ENV,
  REACT_APP_RAVEN_DSN,
  REACT_APP_CIRCLE_BRANCH,
  REACT_APP_CIRCLE_SHA1
} = process.env

if (NODE_ENV === 'production') {
  try {
    Sentry.init({
      dsn: REACT_APP_RAVEN_DSN,
      environment:
        REACT_APP_CIRCLE_BRANCH || process.env.BRANCH || 'development',
      release: REACT_APP_CIRCLE_SHA1 || process.env.COMMIT_REF,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
      ignoreErrors: [
        // error will cause a retry and still results in a usable application, so don't log this EN-2251
        'Chunk Load Error',
        // benign/ignorable error according to spec author
        // https://stackoverflow.com/a/50387233
        'ResizeObserver loop limit exceeded'
      ]
    })
  } catch (err) {
    console.error('Unable to initialize Sentry:', err)
  }
}

const rootEl = document.getElementById('root')

Modal.setAppElement(rootEl)

Modal.defaultStyles.content = null
Modal.defaultStyles.overlay = null

ReactDOM.render(<Root />, rootEl)
